import React, { useState } from "react";
import { Switch } from "antd";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { toggleNegativeMark } from "../../services/settings/settings.slice";
import "./settings.scss";
import { showSuccess } from "../../utils/util.fns";

const NegativeMark: React.FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const isNegativeMark = useAppSelector((store) => store.settings.isNegativeMark);
	const [switchToggle, setSwitchToggle] = useState<boolean>(isNegativeMark);
	const handleToggle = (checked: boolean) => {
		setSwitchToggle(checked);
		showSuccess(checked? "Negative marks enabled" : "Negative marks disabled");
		dispatch(toggleNegativeMark(checked));
	};
	return (
		<div className="d-flex justify-content-between negative_mark">
			<div className="font_16">Negative Marks</div>
			<div className="custom_main_form">
				<Switch
					checked={switchToggle}
					onChange={(checked) => {
						handleToggle(checked);
					}}
				/>
			</div>
		</div>
	);
};

export default NegativeMark;
